import { createRoot } from 'react-dom/client'
import { registerSW } from 'virtual:pwa-register'
import App from './App.tsx'
import './index.css'

if ("serviceWorker" in navigator) {
  registerSW({ immediate: true });

  // O SW ativa a versão nova sozinho (skipWaiting), mas a aba já aberta continua
  // rodando o JS antigo até recarregar — força esse reload quando o controller trocar.
  let reloaded = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (reloaded) return;
    reloaded = true;
    window.location.reload();
  });
}

createRoot(document.getElementById("root")!).render(<App />);
